import React from 'react';

function VenueTab({ venues, onEdit, onDelete, onNew }) {
  return (
    <>
      <header className="courses-header">
        <div>
          <h1>Lokaler</h1>
          <p>Hantera kurslokaler och konferenshotell</p>
        </div>
        <button className="btn btn-primary" onClick={onNew}>
          + Ny lokal
        </button>
      </header>

      <div className="courses-table-container">
        <table className="courses-table">
          <thead>
            <tr>
              <th>Namn</th>
              <th>Adress</th>
              <th>Stad</th>
              <th>Kapacitet</th>
              <th>Pris/dag</th>
              <th>Kontakt</th>
              <th>Status</th>
              <th>Åtgärder</th>
            </tr>
          </thead>
          <tbody>
            {venues.map(venue => (
              <tr key={venue.id}>
                <td className="course-name-cell">{venue.name}</td>
                <td>{venue.address}</td>
                <td>{venue.city}</td>
                <td>{venue.capacity ? `${venue.capacity} pers` : '-'}</td>
                <td>{venue.pricePerDay ? `${venue.pricePerDay} kr` : '-'}</td>
                <td>{venue.contactPerson || venue.contactEmail || '-'}</td>
                <td>
                  <span className={`status-badge ${venue.isActive ? 'active' : 'inactive'}`}>
                    {venue.isActive ? 'Aktiv' : 'Inaktiv'}
                  </span>
                </td>
                <td>
                  <div className="table-actions">
                    <button className="btn btn-secondary btn-small" onClick={() => onEdit(venue)}>
                      Redigera
                    </button>
                    <button className="btn btn-danger btn-small" onClick={() => onDelete(venue)}>
                      Ta bort
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {venues.length === 0 && (
          <div className="no-data">
            <p>Inga lokaler registrerade.</p>
            <p>Klicka på "+ Ny lokal" för att lägga till en.</p>
          </div>
        )}
      </div>
    </>
  );
}

function VenueModal({ show, editing, form, setForm, onSubmit, onClose }) {
  if (!show) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content modal-large" onClick={(e) => e.stopPropagation()}>
        <h2>{editing ? 'Redigera lokal' : 'Lägg till ny lokal'}</h2>
        <form onSubmit={onSubmit}>
          <div className="form-group">
            <label>Lokalnamn *</label>
            <input
              type="text"
              value={form.name}
              onChange={(e) => setForm({...form, name: e.target.value})}
              required
              placeholder="T.ex. Best Western Kom Hotel"
            />
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>Adress *</label>
              <input
                type="text"
                value={form.address}
                onChange={(e) => setForm({...form, address: e.target.value})}
                required
                placeholder="T.ex. Döbelnsgatan 17"
              />
            </div>
            <div className="form-group">
              <label>Stad *</label>
              <input
                type="text"
                value={form.city}
                onChange={(e) => setForm({...form, city: e.target.value})}
                required
                placeholder="T.ex. Stockholm"
              />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>Pris per dag (kr)</label>
              <input
                type="number"
                value={form.pricePerDay}
                onChange={(e) => setForm({...form, pricePerDay: e.target.value})}
                placeholder="3500"
              />
            </div>
            <div className="form-group">
              <label>Max antal personer</label>
              <input
                type="number"
                value={form.capacity}
                onChange={(e) => setForm({...form, capacity: e.target.value})}
                placeholder="25"
              />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>Avbokningsdagar</label>
              <input
                type="number"
                value={form.cancellationDays}
                onChange={(e) => setForm({...form, cancellationDays: e.target.value})}
                placeholder="14"
              />
            </div>
            <div className="form-group">
              <label>Betyg (1-5)</label>
              <select
                value={form.rating}
                onChange={(e) => setForm({...form, rating: e.target.value})}
              >
                <option value="">Ej betygsatt</option>
                <option value="5">5 - Utmärkt</option>
                <option value="4">4 - Bra</option>
                <option value="3">3 - OK</option>
                <option value="2">2 - Dålig</option>
                <option value="1">1 - Mycket dålig</option>
              </select>
            </div>
          </div>
          <div className="form-group">
            <label>Kontaktperson</label>
            <input
              type="text"
              value={form.contactPerson}
              onChange={(e) => setForm({...form, contactPerson: e.target.value})}
              placeholder="T.ex. Anna Andersson"
            />
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>E-post</label>
              <input
                type="email"
                value={form.contactEmail}
                onChange={(e) => setForm({...form, contactEmail: e.target.value})}
                placeholder="konferens@hotell.se"
              />
            </div>
            <div className="form-group">
              <label>Telefon</label>
              <input
                type="tel"
                value={form.contactPhone}
                onChange={(e) => setForm({...form, contactPhone: e.target.value})}
                placeholder="08-123 45 67"
              />
            </div>
          </div>
          <div className="form-group">
            <label>Faciliteter</label>
            <input
              type="text"
              value={form.facilities}
              onChange={(e) => setForm({...form, facilities: e.target.value})}
              placeholder="Projektor, whiteboard, wifi, fika inkl."
            />
          </div>
          <div className="form-group">
            <label>Avbokningsvillkor</label>
            <textarea
              value={form.cancellationPolicy}
              onChange={(e) => setForm({...form, cancellationPolicy: e.target.value})}
              rows="2"
              placeholder="T.ex. Kostnadsfri avbokning 14 dagar innan..."
            />
          </div>
          <div className="form-group">
            <label>Anteckningar (interna)</label>
            <textarea
              value={form.notes}
              onChange={(e) => setForm({...form, notes: e.target.value})}
              rows="3"
              placeholder="T.ex. Rum Öresund är bättre än Kattegatt..."
            />
          </div>
          <div className="form-group checkbox-group">
            <label>
              <input
                type="checkbox"
                checked={form.isActive}
                onChange={(e) => setForm({...form, isActive: e.target.checked})}
              />
              Aktiv (visas i lokallistor och kan väljas för nya kurstillfällen)
            </label>
          </div>
          <div className="form-actions">
            <button type="submit" className="btn btn-success">
              {editing ? 'Spara ändringar' : 'Lägg till lokal'}
            </button>
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Avbryt
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export { VenueTab, VenueModal };
